import {
  RewardBanner,
  RewardBannerFormValues,
  RewardBannerPrizeType,
  RewardBannerButtonAction,
} from './types/RewardBannerTypes';
import { REWARDS_PROMO_TYPE_KEY } from '../../utils/promotionUtils';

export { REWARDS_PROMO_TYPE_KEY };

function createEmptyPrize() {
  return {
    prizeType: RewardBannerPrizeType.None,
    prizeValue: '',
  };
}

export function createEmptyRewardBannerFormValues(): RewardBannerFormValues {
  return {
    title: '',
    description: '',
    label: '',
    priority: 1,
    buttonText: '',
    specialRequirements: '',
    buttonAction: RewardBannerButtonAction.Story,
    buttonTarget: '',
    prize: createEmptyPrize(),
    active: false,
    imageUrl: '',
  };
}

export function rewardBannerToFormValues(rewardBanner: RewardBanner): RewardBannerFormValues {
  let prize = createEmptyPrize();
  if (rewardBanner.prize) {
    try {
      prize = JSON.parse(rewardBanner.prize);
    } catch {
      prize = createEmptyPrize();
    }
  }

  return {
    id: rewardBanner.id,
    title: rewardBanner.title,
    description: rewardBanner.description,
    label: rewardBanner.label || '',
    priority: rewardBanner.priority,
    buttonText: rewardBanner.buttonText,
    specialRequirements: rewardBanner.specialRequirements || '',
    buttonAction: rewardBanner.buttonAction,
    buttonTarget: rewardBanner.buttonTarget || '',
    prize,
    active: rewardBanner.active,
    imageUrl: rewardBanner.imageUrl,
  };
}

export function createRewardBannerFormData(values: RewardBannerFormValues) {
  const formData = new FormData();
  formData.append('title', values.title);
  formData.append('description', values.description);
  formData.append('label', values.label);
  formData.append('priority', String(values.priority));
  formData.append('buttonText', values.buttonText);
  formData.append('specialRequirements', values.specialRequirements);
  formData.append('buttonAction', values.buttonAction);
  formData.append('buttonTarget', values.buttonTarget);
  formData.append('prize', JSON.stringify(values.prize));
  formData.append('active', values.active ? 'true' : 'false');
  if (values.newCoverImage) {
    formData.append('image', values.newCoverImage.file, values.newCoverImage.fileName);
  } else if (values.imageUrl) {
    formData.append('imageUrl', values.imageUrl);
  }
  return formData;
}
